import React from 'react';
// Removed react-helmet-async
import ValidationScripts from './Shared/ValidationScripts';

const Layout = ({ children, title = "", pageClass = "" }) => {

  return (
    <>
      <ValidationScripts />
      <div className={`layout-wrapper ${pageClass}`}>
        <div className="container">
          <main role="main" className="pb-3">
            {children}
          </main>
        </div>
      </div>
    </>
  );
};

export default Layout;
